import confetti from "canvas-confetti"
import type { CreateTypes as ConfettiInstance } from "canvas-confetti"

const AMBER = "#cf8a28"
const AMBER_LIGHT = "#e0a854"
const EMERALD = "#10b981"
const EMERALD_LIGHT = "#34d399"
const NEUTRAL = "#f5f5f4"

let cachedInstance: ConfettiInstance | null = null
let cachedCanvas: HTMLCanvasElement | null = null

function getInstance(): ConfettiInstance | null {
  if (typeof window === "undefined") return null
  if (cachedInstance && cachedCanvas?.isConnected) return cachedInstance

  const canvas = document.createElement("canvas")
  canvas.setAttribute("aria-hidden", "true")
  Object.assign(canvas.style, {
    position: "fixed",
    inset: "0",
    width: "100vw",
    height: "100vh",
    pointerEvents: "none",
    zIndex: "2147483646",
  })
  document.body.appendChild(canvas)
  cachedCanvas = canvas
  cachedInstance = confetti.create(canvas, { resize: true, useWorker: true })
  return cachedInstance
}

type ConfettiOrigin = HTMLElement | { x: number; y: number } | React.MouseEvent<HTMLElement>

function resolveOrigin(source: ConfettiOrigin): { x: number; y: number } {
  if ("clientX" in source && "clientY" in source) {
    return {
      x: source.clientX / window.innerWidth,
      y: source.clientY / window.innerHeight,
    }
  }
  if ("getBoundingClientRect" in source) {
    const rect = source.getBoundingClientRect()
    return {
      x: (rect.left + rect.width / 2) / window.innerWidth,
      y: (rect.top + rect.height / 2) / window.innerHeight,
    }
  }
  return { x: source.x, y: source.y }
}

export function fireCouponConfetti(source: ConfettiOrigin | null | undefined) {
  if (typeof window === "undefined") return
  const fire = getInstance()
  if (!fire) return

  const origin = source ? resolveOrigin(source) : { x: 0.5, y: 0.4 }

  fire({
    particleCount: 28,
    spread: 60,
    startVelocity: 26,
    decay: 0.92,
    scalar: 0.72,
    ticks: 110,
    gravity: 1.1,
    origin,
    colors: [AMBER, AMBER_LIGHT, EMERALD, EMERALD_LIGHT, NEUTRAL],
    shapes: ["circle", "square"],
    disableForReducedMotion: true,
  })
}
